const SESSION_KEY = 'rand&@~';

const getPlantSession = () => {
  const sp = sessionStorage.getItem(SESSION_KEY);
  if (sp) {
    return String(sp).replace(/\/"/g, '');
  }
  return null;
};

const setPlantSession = (params) => {
  try {
    sessionStorage.setItem(SESSION_KEY, params);
  } catch (e) {}
};

const clearPlantSession = () => {
  sessionStorage.removeItem(SESSION_KEY);
};

export { getPlantSession, setPlantSession, clearPlantSession };
